import React from 'react';
import { makeStyles } from '@mui/styles';
import LandscapePaperLayout from '../@common/landscape/LandscapePaperLayout';
import GridWithText from '../@common/GridWithText';
import { WorksheetBaseProps } from '../@types';
import { LwtCopyrightDoubleLines } from '../@common/LwtCopyright';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

type NameTracingPrekTo1Props = WorksheetBaseProps & {
  value: string;
  isWide?: boolean;
  isExtraWide?: boolean;
  printRef?: React.RefObject<HTMLDivElement>;
};

const NameTracingPrekTo1 = ({
  onChange,
  isWide,
  isExtraWide,
  valueMap,
  printRef
}: NameTracingPrekTo1Props) => {
  const classes = useStyles();

  const handleChange = (key, value) => {
    onChange({
      [key]: value
    });
  };

  return (
    <LandscapePaperLayout
      isWide={isWide}
      isExtraWide={isExtraWide}
      printRef={printRef}
      wrapperStyles={{ alignItems: 'flex-start !important' }}
    >
      <GridWithText
        width={isExtraWide ? 1000 : 650}
        height={isExtraWide ? 190 : 160}
        numOfCols={1}
        numOfRows={1}
        handleChange={handleChange}
        valueMap={valueMap}
        spaceBtwnCols={8}
        textLinePaddingTop={75}
        isWide={isWide}
        isExtraWide={isExtraWide}
        placeholder={t('name')}
        alignItemsLeft
        color="#D5D6D6"
        printGray
      />
      <LwtCopyrightDoubleLines
        isLandscape
        isWide={isWide}
        isExtraWide={isExtraWide}
        containerStyle={{
          position: 'absolute',
          top: '280px',
          left: '30px',
          display: 'flex',
          height: 100,
          flexDirection: 'column',
          justifyContent: 'flex-end'
        }}
      />
      <div
        className={classes.cutLine}
        style={{
          padding: '30px 0 30px'
        }}
      />
      <GridWithText
        width={isExtraWide ? 1000 : 650}
        height={isExtraWide ? 190 : 160}
        numOfCols={1}
        numOfRows={1}
        handleChange={handleChange}
        valueMap={valueMap}
        spaceBtwnCols={8}
        textLinePaddingTop={75}
        isWide={isWide}
        isExtraWide={isExtraWide}
        placeholder={t('name')}
        containerPaddingTop={60}
        alignItemsLeft
        inputOffset={1}
        color="#D5D6D6"
        printGray
      />
    </LandscapePaperLayout>
  );
};

const useStyles = makeStyles(() => ({
  cutLine: {
    width: '1100px',
    margin: 'auto auto',
    backgroundImage: "url('http://i.stack.imgur.com/cXciH.png')",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right',
    position: 'relative',
    overflow: 'hidden',
    '&::after': {
      content: '""',
      position: 'relative',
      top: '50%',
      display: 'block',
      borderTop: '3px dashed gray',
      marginTop: '-3px',
      marginRight: 35
    }
  }
}));

export default NameTracingPrekTo1;
